import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const PROCUREMENT_VALIDATION = FORM_FIELDS.INVENTORY.PROCUREMENT;

export const procurementValidationSchema = yup.object().shape({
  // [PROCUREMENT_VALIDATION.PURCHASE_DATE]: yup
  //   .string()
  //   .required("Please provide purchase date"),

  // [PROCUREMENT_VALIDATION.LOT_NO]: yup
  //   .string()
  //   .required("Lot Number is a required field"),

  // [PROCUREMENT_VALIDATION.WARRANTY_START]: yup
  //   .string()
  //   .required("Please provide warranty start date"),

  [PROCUREMENT_VALIDATION.WARRANTY_END]: yup
    .string()
    .required("Please provide warranty end date"),
  // [PROCUREMENT_VALIDATION.INVENTORY_TYPE]: yup
  //   .string()
  //   .required("Inventory Type is required"),

  [PROCUREMENT_VALIDATION.UNIT]: yup.number(),
  [PROCUREMENT_VALIDATION.UNIT_PRICE]: yup.number(),
  [PROCUREMENT_VALIDATION.AMOUNT]: yup.number(),
});

export type ProcurementValidationSchemaType = yup.InferType<
  typeof procurementValidationSchema
>;
